import { detect } from 'detect-browser';
import setupPromisePolyfills from './polyfills/PromisePolyfills';
import setupArrayPolyfills from './polyfills/ArrayPolyfills';
import setupArrayUtilPolyfills from './polyfills/ArrayUtilPolyfills';
import setupBufferPolyfills from './polyfills/BufferPolyfills';
import setupDatePolyfills from './polyfills/DatePolyfills';
import setupStringPolyfills from './polyfills/StringPolyfills';
import setupObjectPolyfills from './polyfills/ObjectPolyfills';
import setupArrayBufferPolyfills from './polyfills/ArrayBufferPolyfills';

// Add missing property names to the React DomAttribute interface, this is to allow the '@mui/x-date-pickers' to work with '@types/react'.
declare global {
	namespace React {
		interface DOMAttributes<T> {
			onResize?: ReactEventHandler<T> | undefined;
			onResizeCapture?: ReactEventHandler<T> | undefined;
			nonce?: string | undefined;
		}
	}
}

var Setup = () => {
	// Handle polyfills.
	setupPolyfills();
}

var setupPolyfills = () => {
	// Apply polyfills by browser compatibility.
	var browser = detect();
	switch (browser && browser.name) {
		case 'ie':
			setupPromisePolyfills();
			setupArrayPolyfills();
			setupObjectPolyfills();
			break;
		default:
			break;
	}

	//Apply polyfills for all browsers.
	setupStringPolyfills();
	setupArrayUtilPolyfills();
	setupArrayBufferPolyfills();
	setupDatePolyfills();
	setupBufferPolyfills();
}

Setup();

